import { FC } from 'react';
import Button from '@srm/ui/button';
import type { ITourPublished } from '@models/tours/ITourPublished';

interface ITourChainPromptProps {
    tour: ITourPublished;
    onAccept: (tour: ITourPublished) => void;
    onDismiss: () => void;
}

const TourChainPrompt: FC<ITourChainPromptProps> = ({ tour, onAccept, onDismiss }) => {
    return (
        <div
            style={{
                position: 'fixed',
                bottom: 32,
                right: 32,
                zIndex: 10001,
                background: 'var(--surface-raised)',
                color: 'var(--text-primary)',
                borderRadius: 12,
                padding: 20,
                maxWidth: 360,
                boxShadow: 'var(--shadow-lvl4)',
            }}
        >
            <div style={{ fontWeight: 'var(--fw-600)', fontSize: 'var(--fz-14)', marginBottom: 8 }}>
                Продолжить обучение?
            </div>
            <div
                style={{
                    fontSize: 'var(--fz-14)',
                    lineHeight: 'var(--lh-text)',
                    marginBottom: 16,
                    color: 'var(--text-secondary)',
                }}
            >
                Следующий тур: {tour.title}
            </div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                <Button variant="secondary" size="sm" onClick={onDismiss}>
                    Нет, спасибо
                </Button>
                <Button variant="primary" size="sm" onClick={() => onAccept(tour)}>
                    Начать
                </Button>
            </div>
        </div>
    );
};

export default TourChainPrompt;
